import { render, staticRenderFns } from "./SpreadsheetEditor.vue?vue&type=template&id=82f4aeac&scoped=true"
import script from "./SpreadsheetEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpreadsheetEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpreadsheetEditor.vue?vue&type=style&index=0&id=82f4aeac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f4aeac",
  null
  
)

export default component.exports